import { useDroppable } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import type { ReactNode } from "react";
import type { Stage, Task } from "../../api/types";
import { cx } from "../../lib/format";
import { STAGE_KIND_LABEL } from "../../lib/status";
import { SortableTaskCard } from "./TaskCard";

export const COLUMN_PREFIX = "col:";

export function BoardColumn({
  stageKey,
  stage,
  tasks,
  highlighted,
  selectedId,
  onOpen,
  header,
}: {
  stageKey: string;
  stage: Stage | undefined;
  tasks: Task[];
  highlighted: boolean;
  selectedId: string | undefined;
  onOpen: (t: Task) => void;
  header?: ReactNode;
}) {
  const { setNodeRef } = useDroppable({ id: COLUMN_PREFIX + stageKey, data: { type: "column", stageKey } });
  return (
    <section className={cx("column", highlighted && "column-over")} aria-label={stage?.name ?? stageKey}>
      <header className="column-header">
        <span className="column-title">{stage?.name ?? stageKey}</span>
        <span className="column-count muted">{tasks.length}</span>
        {stage && <span className="column-kind muted">{STAGE_KIND_LABEL[stage.kind]}</span>}
        {!stage && <span className="column-kind muted">not in current workflow</span>}
      </header>
      {header}
      <div ref={setNodeRef} className="column-body">
        <SortableContext items={tasks.map((t) => t.id)} strategy={verticalListSortingStrategy}>
          {tasks.map((t) => (
            <SortableTaskCard
              key={t.id}
              task={t}
              stage={stage}
              selected={t.id === selectedId}
              onOpen={() => onOpen(t)}
            />
          ))}
        </SortableContext>
        {tasks.length === 0 && <div className="column-empty muted">No tasks</div>}
      </div>
    </section>
  );
}
